<template>
  <nav class="menu">
    <ul>
      <li
        v-for="item in items"
        :key="item.to"
        :class="{ 'disable-on-mobile': item.disableOnMobile }"
      >
        <ButtonNav v-bind="item" />
      </li>
    </ul>
  </nav>
</template>
<script lang="ts" setup>
const { items } = useNavigationMain();
</script>
<style lang="scss" scoped>
ul {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-around;
  height: var(--footer_height);

  @include above('l') {
    display: none;
  }
}

li {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0.8rem 0;
  list-style: none;
}
</style>
